import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    window.addEventListener("applicationNavigationProposal", this.handleNavigationProposal);
  }

  disconnect() {
    window.removeEventListener("applicationNavigationProposal", this.handleNavigationProposal);
  }

  handleNavigationProposal(e) {
    const path = e?.detail?.path;

    if (!path) return;

    Turbo.visit(path);
  }
}
